var _path, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83878 9.98056C1.73014 9.82323 1.73014 9.62138 1.83878 9.46405C2.59481 8.36918 5.77208 4.16675 9.99996 4.16675C14.2278 4.16675 17.4051 8.36918 18.1611 9.46405C18.2698 9.62138 18.2698 9.82323 18.1611 9.98056C17.4051 11.0754 14.2278 15.2779 9.99996 15.2779C5.77208 15.2779 2.59482 11.0754 1.83878 9.98056Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 12.5001C11.5341 12.5001 12.7777 11.2565 12.7777 9.72236C12.7777 8.18823 11.5341 6.94458 9.99995 6.94458C8.46582 6.94458 7.22217 8.18823 7.22217 9.72236C7.22217 11.2565 8.46582 12.5001 9.99995 12.5001Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.51301,
    y: 3.87754,
    width: 1.99759,
    height: 18.6815,
    transform: "rotate(-44.794 2.51301 3.87754)",
    fill: "#90A4AE",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 9.33333 11.5 8 10 8L12 10Z",
    fill: "#90A4AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 10.6667 8.4 12 10 12L8 10Z",
    fill: "#90A4AE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/passwordHide.5f5fb076951d0a48da7478119b181216.svg";
export { ForwardRef as ReactComponent };